import ApplicationAdapter from 'eflex/adapters/application';

export default class DatalogicAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
